var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M2 8a8 8 0 1 1 16 0c0 2.504-1.397 4.403-2 5.1l-5.245 6.032a1 1 0 0 1-1.51 0L4 13.1c-.738-.854-2-2.596-2-5.1m8 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
})));
export default SvgIconLocation;